import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame } from "lucide-react";
import { getTrending } from "@/lib/api";
import { articlePath, formatRelativeDate } from "@/lib/readoo";
import { CategoryTag as _CT } from "@/components/primitives";

function Widget({ title, icon: Icon, accent, children }) {
  return (
    <section className="bg-surfaceSecondary border border-hair rounded-2xl p-5">
      <h3 className="flex items-center gap-2 font-sans text-sm font-bold uppercase tracking-wider text-onSurface border-b border-hair pb-3 mb-2">
        <Icon size={16} style={{ color: accent }} /> {title}
      </h3>
      {children}
    </section>
  );
}

function MiniItem({ a }) {
  return (
    <Link to={articlePath(a)} data-testid={`sidebar-item-${a.article_id}`} className="group flex flex-col gap-1 py-2.5 border-b border-hair/50 last:border-0">
      <_CT category={a.category} className="text-[10px]" />
      <span className="font-serif text-[1rem] font-semibold leading-snug text-onSurface group-hover:text-brand transition-colors line-clamp-2">
        {a.title}
      </span>
      <span className="text-[10px] font-mono text-subtle">{formatRelativeDate(a.published_at)}</span>
    </Link>
  );
}

export function Sidebar() {
  const [trending, setTrending] = useState([]);

  useEffect(() => {
    getTrending(10).then((r) => setTrending(r.trending || [])).catch(() => {});
  }, []);

  return (
    <aside className="space-y-6">
      {trending.length > 0 && (
        <Widget title="Più letti" icon={Flame} accent="#f59e0b">
          <div>{trending.map((a) => <MiniItem key={a.article_id} a={a} />)}</div>
        </Widget>
      )}
    </aside>
  );
}
